import React, { useState, useEffect, useRef } from "react";
import { ReactComponent as Close } from "../../../../assets/images/teamclose.svg";
import { ReactComponent as Ronald } from "../../../../assets/images/Ronald.svg";
import { ReactComponent as TicketID } from "../../../../assets/images/TicketImages/ticketid.svg";
import { ReactComponent as Created } from "../../../../assets/images/TicketImages/created.svg";

import { ReactComponent as LastMessage } from "../../../../assets/images/TicketImages/lastmessage.svg";
import { ReactComponent as Status } from "../../../../assets/images/TicketImages/status.svg";
import { ReactComponent as Source } from "../../../../assets/images/TicketImages/source.svg";
import { ReactComponent as Tag } from "../../../../assets/images/TicketImages/tag.svg";
import { ReactComponent as Dropdown } from "../../../../assets/images/dropdown-arrow.svg";
import { useDispatch, useSelector } from "react-redux";
import { updateTicket } from "../../../../store/features/updateTicket";
import { toast, ToastContainer } from "react-toastify";
import { getTicketById } from "../../../../store/features/getTicketById";
import AssignTicketPopup from "./AssignTicketPopup";
import AssigneTicket from "./Assigne";
import GroupTicket from "./TicketGroup";
import RequestTicket from "./Reguester";
import { Select, MenuItem, FormControl } from "@mui/material";
import { ReactComponent as Urgent } from "../../../../assets/images/TicketImages/urgent.svg";
import { ReactComponent as High } from "../../../../assets/images/TicketImages/high.svg";
import { ReactComponent as Medium } from "../../../../assets/images/TicketImages/medium.svg";
import { ReactComponent as Low } from "../../../../assets/images/TicketImages/low.svg";
import { getTicketMessagesById } from "../../../../store/features/getTicketMessagesById";
import ChangeRequesterPopup from "./ChangeRequesterPopup";
import TagMenu from "../../../dashboardcomponents/ChatComponents/TagMenu";
import AddRequesterPopup from "./AddRequesterPopup";
import TagPopup from "../../../dashboardcomponents/ChatComponents/TagMenuPopup";
import { deleteTicketTagById } from "../../../../store/features/deleteTicketTagById";
import { getAllTickets } from "../../../../store/features/getAllTickets";
import { addTicketTagById } from "../../../../store/features/addTicketTagById";
import { useNavigate } from "react-router-dom";
import ChangeGroupPopup from "./ChangeGroupPopup";
import { useSocket } from "../../../../SocketContext";
import TranscriptModal from "./TranscriptModal";
import { ReactComponent as TranscriptIcon } from "../../../../assets/images/TicketImages/chattick.svg";
import { LIVE_CHAT_HOME_PATH } from "../../../../config/featureFlags";

const TicketChatSideBar = (props) => {
  const {
    activeSidebar,
    setActiveSideBar,
    sideBarData,
    onStatusChange,
    lastMessageTime,
    socketInstance,
    isSocketInitialized,
    setCustomerEmail,
    setCustomerName,
    customerEmail = "",
    customerName = "",
    transcriptMessages = [],
  } = props;
  const dispatch = useDispatch();
  const socket = useSocket();
  const { loading: updateLoading, error: updateError } = useSelector(
    (state) => state.updateTicket
  );
  const userData = useSelector((state) => state.loginToken);
  const isAgent = userData?.response?.user?.role_name === "agent";

  const [status, setStatus] = useState(sideBarData?.status || "open");
  const [priority, setPriority] = useState(sideBarData?.priority || "low");
  const [tags, setTags] = useState(sideBarData?.tags || []);
  const [assignee, setAssignee] = useState(sideBarData?.assignee || null);
  const [groups, setGroups] = useState(sideBarData?.groups || [])
  const [showAssignPopup, setShowAssignPopup] = useState(false);
  const [showChangeRequesterPopup, setShowChangeRequesterPopup] =
    useState(false);
  const [openTagMenu, setOpenTagMenu] = useState(false);
  const [showAddRequesterPopup, setShowAddRequesterPopup] = useState(false);
  const [showChangeGroupPopup, setShowChangeGroupPopup] = useState(false);
  const [currentCCEmails, setCurrentCCEmails] = useState(sideBarData?.ccEmails || []);
  const [showTranscriptModal, setShowTranscriptModal] = useState(false);
  const navigate = useNavigate();
  /**
   * Non-zero while a tag write is running. Ticket refetches triggered elsewhere
   * can land mid-write and still carry the old tag list, which would undo the
   * tag the agent just added.
   */
  const pendingTagWritesRef = useRef(0);

  useEffect(() => {
    if (sideBarData) {
      setStatus(sideBarData.status || "open");
      setPriority(sideBarData.priority || "low");
      if (pendingTagWritesRef.current === 0) {
        setTags(sideBarData.tags || []);
      }
      setAssignee(sideBarData.assignee || null);
      setGroups(sideBarData.groups || []);
      setCustomerEmail(sideBarData.customerEmail || "");
      setCustomerName(sideBarData.customerName || "");
      setCurrentCCEmails(sideBarData.ccEmails || []);
    }
  }, [sideBarData]);

  useEffect(() => {
    if (!socketInstance || !sideBarData?._id || !isSocketInitialized) {
      return;
    }

    const handleTicketUpdate = (data) => {
      if (data.priority) {
        setPriority(data.priority);
      }
      if (data.status) {
        setStatus(data.status);
        if (onStatusChange) {
          onStatusChange(data.status);
        }
      }
      if (data.assignee) {
        setAssignee(data.assignee);
        console.log("assignee rec", data);
      }
      if (data.groups) {
        setGroups((prevGroups) => {
          return data.groups.map(g => {
            return {
              _id: g.id,
              id: g.id,
              title: g.name,
              group_image: g.image,
              agents: g.agents,
            };
          });
        });
      }
      if (data.customerEmail) {
        setCustomerEmail(data.customerEmail);
      }
      if (data.customerName) {
        setCustomerName(data.customerName);
      }
    };



    const handleTicketMessageNew = (data) => {
      console.log("[TicketChatSideBar] Received ticket:message:new event:", data);
      if (
        data.meta?.type === "agentReply" || data?.meta?.type === "customerReply" &&
        data.meta?.value?.to
      ) {
        setStatus(data.meta.value.to);
        if (onStatusChange) {
          onStatusChange(data.meta.value.to);
        }
      }
    };

    socketInstance.on("ticket:message:new", handleTicketMessageNew);
    socketInstance.on('ticket:update', handleTicketUpdate);

    return () => {
      socketInstance.off("ticket:message:new", handleTicketMessageNew);
      socketInstance.off('ticket:update', handleTicketUpdate);
    };
  }, [socketInstance, sideBarData?._id, onStatusChange, isSocketInitialized]);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const handleStatusChange = async (newStatus) => {
    const oldStatus = status;

    // Update local state immediately
    setStatus(newStatus);

    // Notify parent component about status change
    if (onStatusChange) {
      onStatusChange(newStatus);
    }

    // Create status change message
    const statusChangeMessage = {
      type: "status_change",
      oldStatus: oldStatus.charAt(0).toUpperCase() + oldStatus.slice(1),
      newStatus: newStatus.charAt(0).toUpperCase() + newStatus.slice(1),
      created_at: new Date().toISOString(),
      _id: `status-change-${Date.now()}`,
      isAdmin: true,
      agent: userData?.response?.user,
    };

    // Add status change message optimistically
    dispatch({
      type: "getTicketMessagesById/optimisticAdd",
      payload: statusChangeMessage,
    });

    try {
      // Update ticket status
      await dispatch(
        updateTicket({
          ticketId: sideBarData._id,
          updateData: { status: newStatus },
        })
      ).unwrap();

      toast.success("Status updated successfully");

      if (socket && sideBarData?._id && oldStatus !== newStatus) {
        socket.emit('ticket-status-changed', {
          ticketId: sideBarData._id,
          oldStatus,
          newStatus,
          agentId: userData?.response?.user?._id,
          businessId: userData?.response?.user?.business_id,
          ticket: {
            ...sideBarData,
            status: newStatus
          }
        });
      }

      await dispatch(getAllTickets());
      await dispatch(getTicketMessagesById(sideBarData._id));
    } catch (error) {
      console.error("Failed to update status:", error);

      // Revert local state
      setStatus(oldStatus);
      if (onStatusChange) {
        onStatusChange(oldStatus);
      }

      // Remove optimistic message
      dispatch({
        type: "getTicketMessagesById/optimisticRemove",
        payload: statusChangeMessage._id,
      });

      let errorMessage = "Failed to update status";
      if (error instanceof Error) {
        errorMessage = error.message;
      } else if (error?.data?.message) {
        errorMessage = error.data.message;
      }

      toast.error(errorMessage);
    }
  };

  const handlePriorityChange = async (newPriority) => {
    const oldPriority = priority;
    setPriority(newPriority);

    try {
      await dispatch(
        updateTicket({
          ticketId: sideBarData._id,
          updateData: { priority: newPriority },
        })
      ).unwrap();
      toast.success("Priority updated successfully");

      await dispatch(getTicketMessagesById(sideBarData._id));
    } catch (error) {
      console.error("Failed to update priority:", error);
      setPriority(oldPriority);
      toast.error("Failed to update priority");
    }
  };

  const handleTagsUpdate = async (selectedTags) => {
    const previousTags = [...tags];
    setTags(selectedTags);
    pendingTagWritesRef.current += 1;
    try {
      const tagIds = selectedTags.map((tag) => tag._id);
      await dispatch(
        addTicketTagById({
          ticketId: sideBarData._id,
          tags: tagIds,
        })
      ).unwrap();
      toast.success("Tags updated successfully");
      await dispatch(getTicketMessagesById(sideBarData?._id)).unwrap();
    } catch (error) {
      setTags(previousTags);
      let errorMessage = "Failed to update tags";
      if (error instanceof Error) {
        errorMessage = error.message;
      } else if (error?.data?.message) {
        errorMessage = error.data.message;
      }
      toast.error(errorMessage);
    } finally {
      pendingTagWritesRef.current = Math.max(
        0,
        pendingTagWritesRef.current - 1
      );
    }
  };

  const handleAssignSuccess = async () => {
    if (sideBarData?._id) {
      await dispatch(getTicketMessagesById(sideBarData._id));
    }
  };

  const handleCCEmailsUpdate = (updatedCCEmails) => {
    setCurrentCCEmails(updatedCCEmails);
  };

  const getSelectedTagIds = () => {
    return tags.map((tag) => tag._id);
  };

  const handleDeleteTag = async (tagId) => {
    const previousTags = [...tags];
    setTags(tags.filter((tag) => tag._id !== tagId));
    pendingTagWritesRef.current += 1;
    try {
      await dispatch(
        deleteTicketTagById({ ticketId: sideBarData._id, tagId })
      ).unwrap();
    } catch (error) {
      setTags(previousTags);
    } finally {
      pendingTagWritesRef.current = Math.max(
        0,
        pendingTagWritesRef.current - 1
      );
    }
  };

  return (
    <>


      {showAssignPopup && (
        <AssignTicketPopup
          setAssignTicketPopup={setShowAssignPopup}
          ticketId={sideBarData?._id}
          currentAssignee={assignee} // <-- use lifted state
          onAssignSuccess={handleAssignSuccess}
        />
      )}

      {showChangeRequesterPopup && (
        <ChangeRequesterPopup
          setOpen={setShowChangeRequesterPopup}
          ticketId={sideBarData?._id}
          currentName={customerName}
          currentEmail={customerEmail}
          onAssignSuccess={handleAssignSuccess}
        />
      )}

      {showAddRequesterPopup && (
        <AddRequesterPopup
          setOpen={setShowAddRequesterPopup}
          ticketId={sideBarData?._id}
          onAssignSuccess={handleAssignSuccess}
          requesterEmail={sideBarData?.customerEmail}
          existingCCEmails={currentCCEmails}
          onCCEmailsUpdate={handleCCEmailsUpdate}
        />
      )}

      {showChangeGroupPopup && (
        <ChangeGroupPopup
          open={showChangeGroupPopup}
          onClose={() => setShowChangeGroupPopup(false)}
          ticketId={sideBarData?._id}
          currentGroups={groups || []}
        />
      )}

      <div
        style={{
          maxHeight: 'calc(100vh - 114px)',
          // Add other styles if needed to override
        }}
        className={`Ticket-Main-SideBar ${activeSidebar
          ? "Ticket-Main-SideBar--open"
          : "Ticket-Main-SideBar--closed"
          }`}
      >
        <div className="Team-SideBar">
          <p className="detail-text">Ticket Details</p>
        </div>

        <div className="AccountType-Main-Container01">
          <div className="AccountType-content">
            <div className="Account-Type01">
              <TicketID />
              <p className="AccountType-text">Ticket ID:</p>
            </div>
            <p className="AccountAgent-text">
              {sideBarData?._id?.slice(-6) || "N/A"}
            </p>
          </div>

          <div className="AccountType-content">
            <div className="Account-Type01">
              <Created />
              <p className="AccountType-text">Created:</p>
            </div>
            <p className="AccountAgent-text">
              {sideBarData?.createdAt
                ? formatDate(sideBarData.createdAt)
                : "N/A"}
            </p>
          </div>

          <div className="AccountType-content">
            <div className="Account-Type01">
              <LastMessage />
              <p className="AccountType-text">Last message:</p>
            </div>
            <p className="AccountAgent-text">
              {lastMessageTime ? formatDate(lastMessageTime) : "N/A"}
            </p>
          </div>

          <div className="AccountType-content">
            <div className="Account-Type01">
              <Status />
              <p className="AccountType-text">Status:</p>
            </div>
            <FormControl size="small" sx={{
              minWidth: "136px",

              "& .MuiInputBase-root": {
                height: "32px !important",

              }
            }}>
              <Select
                value={status}
                onChange={(e) => handleStatusChange(e.target.value)}
                IconComponent={Dropdown}

                sx={{
                  height: "32px",
                  width: "136px",
                  fontSize: "14px",

                  "& .MuiSelect-select": {
                    fontSize: "14px",

                    paddingLeft: "16px",

                  },
                  "& .MuiInputBase-input": {

                    paddingLeft: "16px !important",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#D5DCE1 !important",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#D5DCE1 !important",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#D5DCE1 !important",
                  },
                  "& .MuiSelect-icon": {
                    fontSize: "16px",
                    position: "absolute",
                    top: "50%",
                    transform: "translateY(-50%)",
                    right: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  },
                  "& .MuiSelect-iconOpen": {
                    fontSize: "16px",
                    position: "absolute",
                    top: "50%",
                    transform: "translateY(-50%) rotate(180deg)",
                    right: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  },

                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      border: "1px solid #D5DCE1",
                      marginTop: "4px",
                      width: "120px",
                      padding: ' 0px 8px',

                      borderRadius: "8px",
                      "& .MuiMenuItem-root": {
                        fontSize: "14px",
                        padding: "8px 8px",
                        color: "#405261",
                        "&:hover": {


                          color: '#061522',
                          borderRadius: "8px",
                          background: "#F9FAFA  !important",
                        },
                        "&.Mui-selected": {
                          color: '#061522',
                          borderRadius: "8px",
                          background: "#F9FAFA !important",
                        },
                        "&.Mui-selected:hover": {
                          background: "#F9FAFA  !important", // keep same on hover while selected
                        },
                      },
                    },
                  },
                }}
              >
                {["open", "pending", "solved", "spam"].map((statusOption) => (
                  <MenuItem key={statusOption} value={statusOption}>
                    {statusOption.charAt(0).toUpperCase() +
                      statusOption.slice(1)}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <div className="AccountType-content">
            <div className="Account-Type01">
              <LastMessage />
              <p className="AccountType-text">Priority:</p>
            </div>
            <FormControl size="small" sx={{
              minWidth: "136px",
              "& .MuiInputBase-root": {
                height: "32px !important",
              }
            }}>
              <Select
                value={priority}
                onChange={(e) => handlePriorityChange(e.target.value)}
                IconComponent={Dropdown}
                disabled={updateLoading}

                sx={{
                  height: "32px",
                  width: "136px",
                  fontSize: "14px",

                  "& .MuiSelect-select": {
                    fontSize: "14px",

                    paddingLeft: "16px",

                  },
                  "& .MuiInputBase-input": {

                    paddingLeft: "16px !important",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#D5DCE1 !important",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#D5DCE1 !important",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#D5DCE1 !important",
                  },
                  "& .MuiSelect-icon": {
                    fontSize: "16px",
                    position: "absolute",
                    top: "50%",
                    transform: "translateY(-50%)",
                    right: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  },
                  "& .MuiSelect-iconOpen": {
                    fontSize: "16px",
                    position: "absolute",
                    top: "50%",
                    transform: "translateY(-50%) rotate(180deg)",
                    right: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  },

                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      border: "1px solid #D5DCE1",
                      marginTop: "4px",
                      width: "120px",
                      padding: ' 0px 8px',

                      borderRadius: "8px",
                      "& .MuiMenuItem-root": {
                        fontSize: "14px",
                        padding: "8px 8px",
                        color: "#405261",
                        "&:hover": {


                          color: '#061522',
                          borderRadius: "8px",
                          background: "#F9FAFA  !important",
                        },
                        "&.Mui-selected": {
                          color: '#061522',
                          borderRadius: "8px",
                          background: "#F9FAFA !important",
                        },
                        "&.Mui-selected:hover": {
                          background: "#F9FAFA  !important", // keep same on hover while selected
                        },
                      },
                    },
                  },
                }}


              >
                {["urgent", "high", "medium", "low"].map((priorityOption) => (
                  <MenuItem
                    key={priorityOption}
                    value={priorityOption}

                  >
                    <div style={{ display: "flex", alignItems: "center", gap: priorityOption === "low" ? "15px" : "8px" }}>
                      {priorityOption === "urgent" && <Urgent />}
                      {priorityOption === "high" && <High />}
                      {priorityOption === "medium" && <Medium />}
                      {priorityOption === "low" && <Low style={{ marginLeft: "5px" }} />}
                      &nbsp;
                      {priorityOption.charAt(0).toUpperCase() + priorityOption.slice(1)}
                    </div>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

          </div>

          <div className="AccountType-content">
            <div className="Account-Type01">
              <Source />
              <p className="AccountType-text">Source:</p>
            </div>
            {sideBarData?.chatRoom && (
              <p
                onClick={() =>
                  navigate(`${LIVE_CHAT_HOME_PATH}?roomId=` + sideBarData?.chatRoom)
                }
                style={{
                  cursor: "pointer", textDecorationLine: "underline",
                  textUnderlineOffset: "3px",
                }}
              >
                Chat
              </p>
            )}
            {sideBarData?.isFromWidget && <p>Widget</p>}
            {!sideBarData?.isFromWidget && !sideBarData?.chatRoom && (
              <p>New Ticket</p>
            )}
          </div>
          <div className="tagSparator" />
          <div style={{ display: 'flex', justifyContent: 'space-between' }} className="AccountType-content">
            <div className="Account-Type01">
              {/* <Tag /> */}
              <p className="AccountType-text">Tags:</p>
            </div>

            {tags.length > 0 ? (
              <p
                className="SuperVisorChange"
                style={{ marginLeft: "2px", }}
                onClick={() => setOpenTagMenu(!openTagMenu)}
              >
                +Add tags
              </p>
            ) : (
              <p
                className="SuperVisorChange"
                style={{ marginRight: "10px" }}
                onClick={() => setOpenTagMenu(!openTagMenu)}
              >
                +Add tags
              </p>
            )}
          </div>
          <div
            style={{
              display: "flex",
              gap: "8px",
              flexWrap: "wrap",
              paddingRight: "5px",
              // paddingLeft: "5px",

              justifyContent: "flex-start",
            }}
          >
            {tags.length > 0 && (
              tags.map((tag, idx) => (
                <span
                  key={tag._id}
                  className="TicketTag"
                  style={{
                    display: "flex",
                    alignItems: "center", // Vertically center items
                    justifyContent: "center", // Horizontally center items

                    borderRadius: 999,
                    // background: "#F8F9FA",
                    border: "1px solid #CBD5DF",
                    padding: "0px 16px",
                    height: "32px",
                    textTransform: 'capitalize',
                    fontWeight: 500,
                  }}
                >
                  {tag.name}
                  {tags.length > 1 && (
                    <span
                      style={{

                        marginLeft: 8,
                        marginBottom: "2px",

                        cursor: "pointer",
                        fontSize: 16,

                      }}
                      onClick={() => handleDeleteTag(tag._id)}
                    >
                      ×
                    </span>
                  )}
                </span>
              ))
            )}

          </div>
        </div>

        <div
          style={{ marginTop: "30px" }}
        // onClick={() => {
        //   if (!isAgent) {
        //     setShowAssignPopup(true);
        //   }
        // }}
        >
          <AssigneTicket
            assignee={assignee} // <-- use lifted state
            isAgent={isAgent}
            ticketId={sideBarData?._id}
            setShowAssignPopup={setShowAssignPopup}
          />
        </div>

        <GroupTicket groups={groups} onChangeGroup={() => setShowChangeGroupPopup(true)} />

        <div style={{ marginTop: "8px" }}>
          <RequestTicket
            sideBarData={{
              ...sideBarData,
              customerEmail,
              customerName,
            }}
            setChangeRequesterPopup={setShowChangeRequesterPopup}
            setShowAddRequesterPopup={setShowAddRequesterPopup}
            onCCEmailsUpdate={handleCCEmailsUpdate}
          />
        </div>

        <div style={{ marginTop: "16px", border: "1px solid #E5E9EC", borderRadius: "8px", padding: "16px", width: "100%", boxSizing: "border-box" }}>
          <p className="detail-text" style={{ fontSize: "18px", fontWeight: 600, color: "#061522", marginBottom: "14px", borderBottom: "none" }}>
            Transcripts
          </p>
          <div
            style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", overflow: "hidden" }}
            onClick={() => setShowTranscriptModal(true)}
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 10H4.92133C5.17363 10 5.40431 10.1424 5.51733 10.368L5.81533 10.9647C5.92828 11.1907 6.15932 11.3335 6.412 11.3333H9.58733C9.84002 11.3335 10.0711 11.1907 10.184 10.9647L10.482 10.3687C10.595 10.1426 10.826 9.99988 11.0787 10H14" stroke="#405261" stroke-linecap="round" stroke-linejoin="round" />
              <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C13.1046 2 14 2.89543 14 4V12C14 13.1046 13.1046 14 12 14H4C2.89543 14 2 13.1046 2 12V4C2 2.89543 2.89543 2 4 2H12Z" stroke="#405261" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M10.6663 6.62924L5.33301 6.62923" stroke="#405261" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <p
              className="AccountAgent-text"
              style={{
                fontSize: "14px",
                color: "#405261",
                textDecoration: "none",
                margin: 0,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
              }}
            >
              {sideBarData?.subject || "No transcript available"}
            </p>
          </div>
        </div>

        {updateError && (
          <div style={{ color: "red", marginTop: "10px", textAlign: "center" }}>
            {updateError.message || "Failed to update ticket"}
          </div>
        )}
      </div>

      {openTagMenu && (
        <TagPopup
          onClose={() => setOpenTagMenu(false)}
          onApply={handleTagsUpdate}
          selectedTags={getSelectedTagIds()}
        />
      )}

      <TranscriptModal
        isOpen={showTranscriptModal}
        onClose={() => setShowTranscriptModal(false)}
        ticket={sideBarData}
        messages={transcriptMessages}
      />
    </>
  );
};

export default TicketChatSideBar;
